

import React, { memo } from 'react';
import cx from 'classnames';









const DataTableRow = (props) => {
  const { rowIdAttr, className, children, onClick } = props;

  return (
    <tr
      className={cx('data-table-row', className)}
      data-id={rowIdAttr}
      onClick={onClick}>

      {children}
    </tr>);

};

export default memo(DataTableRow);